module.exports = __webpack_public_path__ + "img/m1.46402ca2.jpg";